<template>
    <div @click="redit" class="my-header" :style="{cursor:is_back ? 'pointer':''}">
        <div class="my-header-title">{{title}}</div>
        <div style="flex:1;margin-left:10px">
            <slot name="content">
            </slot>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{
            }
        },
        props:{
            title:{
                type:String,
                default:'未知'
            },
            is_back:{
                type:Boolean,
                default:false
            },
            type:{
                type:String,
                default:'3'
            }
        },
        methods :{
            redit(){
                if (this.is_back) {
                    this.$router.back()
                }
            }
        }
    }
</script>
<style>

.my-header {
    width:100%;height:70px; background: #fff;border-radius:12px;display: flex; align-items: center;padding:10px 20px
}
.my-header-title{
   font-size:30px;font-weight: bold;color: #0A1629FF;
}
</style>
